import { render } from "./ItemUpload.vue?vue&type=template&id=73c51775"
import script from "./ItemUpload.vue?vue&type=script&lang=js"
export * from "./ItemUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__